/* Clean Drive: cart drawer, product gallery, variant selector, single-item storefront purchase, FAQ and genuine timer. */
(() => {
  'use strict';
  const theme = window.CleanDrive || {};
  const routes = theme.routes || { add: '/cart/add', cart: '/cart', change: '/cart/change' };
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
    style: 'currency', currency: theme.currency || 'CLP'
  }).format(Number(amount || 0) / 100);
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const drawer = $('[data-cart-drawer]');
  let previouslyFocused = null;
  let busy = false;
  let toastTimer;

  const toast = message => {
    const box = $('#cd-toast');
    if (!box) return;
    box.textContent = message;
    box.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => box.classList.remove('is-visible'), 3400);
  };

  const getCart = async () => {
    const response = await fetch(routes.cart + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('No pudimos actualizar el carrito.');
    return response.json();
  };

  function updateCount(count) {
    $$('[data-cart-count]').forEach(node => {
      node.textContent = count;
      node.hidden = !count;
    });
    const drawerCount = $('[data-drawer-count]');
    if (drawerCount) drawerCount.textContent = `(${count})`;
  }

  function addText(parent, tag, text, className = '') {
    const child = document.createElement(tag);
    child.textContent = String(text);
    if (className) child.className = className;
    parent.appendChild(child);
    return child;
  }

  function renderCart(cart) {
    if (!drawer) return;
    const body = $('[data-drawer-items]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    body.replaceChildren();
    updateCount(cart.item_count || 0);
    if (!cart.items || !cart.items.length) {
      const empty = addText(body, 'div', '', 'cd-drawer__empty');
      addText(empty, 'h3', 'Tu carrito está vacío');
      addText(empty, 'p', 'Agrega tu hidrolavadora inalámbrica Clean Drive para comenzar.');
      const link = addText(empty, 'a', 'Ver hidrolavadora →', 'cd-button');
      link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '#comprar';
      foot.hidden = true;
      return;
    }
    for (const [index, item] of cart.items.entries()) {
      const row = addText(body, 'article', '', 'cd-drawer__row');
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || 'Producto';
        image.loading = 'lazy';
        image.width = 88;
        image.height = 88;
        row.appendChild(image);
      } else {
        const image = document.createElement('div');
        image.className = 'cd-drawer__row-media';
        row.appendChild(image);
      }
      const info = addText(row, 'div', '', 'cd-drawer__row-info');
      const title = addText(info, 'strong', item.product_title || item.title);
      if (item.url) {
        const a = document.createElement('a');
        a.href = item.url;
        a.textContent = title.textContent;
        title.replaceChildren(a);
      }
      if (item.variant_title && item.variant_title !== 'Default Title') addText(info, 'p', item.variant_title);
      addText(info, 'p', money(item.final_line_price), 'cd-drawer__price');
      const quantity = addText(info, 'div', '', 'cd-drawer__qty');

      addText(quantity, 'span', `${item.quantity} unidad${item.quantity === 1 ? '' : 'es'}`);
      const remove = addText(quantity, 'button', 'Eliminar', 'cd-remove-link');
      remove.type = 'button';
      remove.addEventListener('click', () => changeLine(index + 1, 0));
    }
    $('[data-drawer-total]', drawer).textContent = money(cart.total_price);
    foot.hidden = false;
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  async function changeLine(line, quantity) {
    if (busy) return;
    busy = true;
    try {
      const res = await fetch(routes.change + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity: quantity > 0 ? 1 : 0 })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'No pudimos cambiar la cantidad.');
      renderCart(data);
    } catch (error) { toast(error.message || 'Error al actualizar el carrito.'); }
    finally { busy = false; }
  }

  async function openCart() {
    if (!theme.cartDrawer || !drawer) {
      window.location.href = routes.cart;
      return;
    }
    previouslyFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-scroll-lock');
    $('.cd-drawer__panel', drawer)?.focus();
    try { await refreshCart(); }
    catch (error) { toast('No pudimos cargar tu carrito.'); }
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-scroll-lock');
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
  }

  $$('[data-open-cart]').forEach(link => link.addEventListener('click', event => {
    if (!theme.cartDrawer || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openCart();
  }));
  $$('[data-close-cart]').forEach(button => button.addEventListener('click', closeCart));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeCart();
    if (event.key !== 'Tab' || !drawer?.classList.contains('is-open')) return;
    const active = $$('a[href],button:not(:disabled),input:not(:disabled),[tabindex="0"]', $('.cd-drawer__panel', drawer)).filter(el => !el.hidden && el.offsetParent !== null);
    if (!active.length) return;
    const first = active[0], last = active[active.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  const menuToggle = $('[data-toggle-menu]');
  const menu = $('[data-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
  });
  $$('[data-mobile-menu] a').forEach(link => link.addEventListener('click', () => {
    menu.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  }));
  const searchToggle = $('[data-toggle-search]');
  const search = $('#cd-search');
  searchToggle?.addEventListener('click', () => {
    if (!search) return;
    search.hidden = !search.hidden;
    searchToggle.setAttribute('aria-expanded', String(!search.hidden));
    if (!search.hidden) $('#cd-search-input')?.focus();
  });

  function initializePurchase(container) {
    const form = $('form.cd-product-form', container);
    if (!form) return;
    const variantId = $('[data-variant-id]', form);
    const variantSelect = $('[data-variant-select]', form);

    const priceDisplay = $('[data-price-current]', container);
    const comparedDisplay = $('[data-price-compare]', container);
    const badge = $('[data-price-badge]', container);
    const addButton = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const error = $('[data-product-error]', form);

    const updateVariant = () => {
      const option = variantSelect?.selectedOptions[0];
      if (!option) return;
      variantId.value = option.value;
      const unitPrice = Number(option.dataset.price) || 0;
      priceDisplay.textContent = option.dataset.formattedPrice || money(unitPrice);
      const compare = Number(option.dataset.compare) || 0;
      comparedDisplay.hidden = compare <= unitPrice;
      comparedDisplay.textContent = compare > unitPrice ? (option.dataset.compareFormatted || money(compare)) : '';
      badge.hidden = compare <= unitPrice;
      badge.textContent = compare > unitPrice ? 'En oferta' : '';
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
      addLabel.textContent = available ? 'Comprar mi hidrolavadora' : 'Agotado';
      const gallery = container.closest('.cd-product-layout')?.querySelector('[data-product-gallery]');
      const mainImage = gallery?.querySelector('[data-main-image]');
      if (option.dataset.image && mainImage) mainImage.src = option.dataset.image;

    };
    variantSelect?.addEventListener('change', updateVariant);
    if (variantSelect) updateVariant();

    form.addEventListener('submit', async event => {
      if (event.submitter && event.submitter.name !== 'add') return;
      event.preventDefault();
      if (addButton.disabled || busy) return;
      busy = true;
      error.hidden = true;
      addButton.disabled = true;
      addLabel.textContent = 'Agregando…';
      try {
        const previousCart = await getCart();
        if (previousCart.item_count > 0) {
          await openCart();
          toast('Ya tienes una hidrolavadora en tu carrito. Para cambiarla, elimina primero la anterior.');
          return;
        }
        const request = new FormData();
        request.set('id', variantId.value);
        request.set('quantity', '1');
        const response = await fetch(routes.add + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }, body: request
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
        await refreshCart();
        if (theme.cartDrawer) await openCart();
        else toast('Producto agregado al carrito.');
      } catch (err) {
        error.textContent = String(err.message || 'Revisa la conexión e inténtalo otra vez.');
        error.hidden = false;
      } finally {
        busy = false;
        addButton.disabled = variantSelect?.selectedOptions[0]?.dataset.available === 'false';
        addLabel.textContent = addButton.disabled ? 'Agotado' : 'Comprar mi hidrolavadora';
      }
    });
  }
  $$('[data-product-purchase]').forEach(initializePurchase);

  $$('[data-product-gallery]').forEach(gallery => {
    const main = $('[data-main-image]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach(button => button.addEventListener('click', () => {
      if (!main) return;
      main.src = button.dataset.src;
      main.alt = button.dataset.alt || 'Fotografía del producto';
      $$('[data-gallery-thumb]', gallery).forEach(thumb => {
        const active = thumb === button;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }));
  });

  $$('[data-countdown]').forEach(countdown => {
    const section = countdown.closest('[data-offer-section]');
    const expires = Date.parse(countdown.dataset.countdown || '');
    if (!Number.isFinite(expires) || expires <= Date.now()) {
      if (section) section.hidden = true;
      return;
    }
    countdown.hidden = false;
    const writeTime = () => {
      const remaining = Math.max(0, expires - Date.now());
      if (!remaining) { if (section) section.hidden = true; clearInterval(timer); return; }
      const total = Math.floor(remaining / 1000);
      const values = {
        '[data-days]': Math.floor(total / 86400),
        '[data-hours]': Math.floor(total / 3600) % 24,
        '[data-minutes]': Math.floor(total / 60) % 60,
        '[data-seconds]': total % 60
      };
      Object.entries(values).forEach(([selector, value]) => {
        const el = $(selector, countdown);
        if (el) el.textContent = String(value).padStart(2, '0');
      });
    };
    let timer;
    writeTime();
    timer = setInterval(writeTime, 1000);
  });
})();

/* Clean Drive B/N V2: progressive motion and mobile CTA */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const targets = document.querySelectorAll('.cd-reveal');
    if (targets.length) {
      document.documentElement.classList.add('cd-has-motion');
      const reveal = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('cd-visible'); observer.unobserve(entry.target); } });
      }, { threshold: .08 });
      targets.forEach(el => reveal.observe(el));
    }
  }
  const mobileCta = document.querySelector('[data-mobile-cta]');
  if (mobileCta) {
    const sync = () => { mobileCta.classList.toggle('is-visible', window.scrollY > 450); };
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }
})();
